import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { RentModel } from 'types/api'
import { BaseResponse } from 'types/utils'

export const rentsQueryKey = ['rents']

export function useRents() {
  async function getRents() {
    const rents = await apiClient.get<BaseResponse<RentModel>>(
      `${SNA_PREFIX}rents`
    )

    return rents.data
  }

  return useQuery({
    queryFn: getRents,
    queryKey: [...rentsQueryKey]
  })
}
